const makeRgba = ([red, green, blue]: [number, number, number], alpha: number): string =>
  `rgba(${red}, ${green}, ${blue}, ${alpha})`

export default makeRgba
